/**
 * The one thing every reference form dialog needs from an `ApiError` and
 * shares no other way: turning `error.details` (field -> messages) into
 * field -> first message. Not i18n-dependent, so it needs no `t` passed in
 * and stays type-safe at every call site the way a loosely-typed shared
 * `describeFailure(t, ...)` would not (`i18next.d.ts` types `t()` against the
 * real bundle; a callback typed `(key: string) => string` would lose that).
 *
 * Mirrors `UserFormDialog.tsx`'s identical `mapDetails`.
 */
export function mapDetails(details: Readonly<Record<string, string[]>>): Record<string, string> {
  const out: Record<string, string> = {};
  for (const [field, messages] of Object.entries(details)) {
    const [first] = messages;
    if (first !== undefined) out[field] = first;
  }
  return out;
}
